// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1YrXs","Label":"BuildControl_Label__1k1jQ","Less":"BuildControl_Less__qQYSI","More":"BuildControl_More__3E8Sb"};